module.exports = __webpack_public_path__ + "static/jade9-d9a9c5f51fdde6263d7713500a9c621a.png";